import '../style.scss'

import type { CommonIcon } from 'shared/ui/StackIcon/keys'

import { useState } from 'react'
import { StackIcon } from 'shared/ui'

import AutomationMode from '../automationMode'
import SubscriptionBilling from '../subscriptionBilling'
import WorkingHours from './workingHours'

const enum Tab {
	Automation,
	WorkingHours,
	SubscriptionBilling
}

const Content = {
	[Tab.Automation]: AutomationMode,
	[Tab.SubscriptionBilling]: SubscriptionBilling,
	[Tab.WorkingHours]: WorkingHours
}

const TABS = [
	{ icon: 'comp-network', key: Tab.Automation, title: 'Automation Mode' },
	{ icon: 'clock', key: Tab.WorkingHours, title: 'Working Hours' },
	{
		icon: 'dollar',
		key: Tab.SubscriptionBilling,
		title: 'Subscription Billing'
	}
]

export function WorkingHoursProfile() {
	const [tab, setTab] = useState(Tab.Automation)
	const Component = Content[tab]

	return (
		<div className='working-hours-profile'>
			<div className='working-hours-profile__header'>
				<div className='container-nav-account'>
					{TABS.map(({ icon, key, title }) => {
						const isActive = tab === key
						return (
							<button
								className={
									isActive ? 'buttonWorkingHoursActive' : 'buttonWorkingHours'
								}
								key={key}
								onClick={() => setTab(key)}
							>
								<div
									className={
										isActive
											? 'working-hours-profile__title'
											: 'working-hours-profile__title-disabled'
									}
								>
									<StackIcon
										icon={icon as CommonIcon}
										style={{ marginRight: '9px' }}
										width={16}
									/>
									{title}
								</div>
							</button>
						)
					})}
				</div>
			</div>
			<div className='working-line-list'>&nbsp;</div>
			<Component />
		</div>
	)
}
